import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getAccessTokenforResource } from 'owa-tokenprovider';

const TEAMS_PROFILE_PICTURE_RESOURCE = 'https://teams.microsoft.com';

/**
 * Fetch the profile picture for a specific team
 * @param team
 */
export default async function fetchTeamProfilePicture(team: any) {
    if (
        !team ||
        !team.teamSiteInformation ||
        !team.teamSiteInformation.groupId ||
        !team.pictureETag ||
        !team.displayName
    ) {
        return null;
    }

    const url: string = `${TEAMS_PROFILE_PICTURE_RESOURCE}/api/mt/beta/teams/${team.teamSiteInformation.groupId}/profilepicture?etag=${team.pictureETag}&displayName=${team.displayName}`;
    const token = await getAccessTokenforResource(
        TEAMS_PROFILE_PICTURE_RESOURCE,
        'TeamsProfilePicture'
    );

    if (!token) {
        throw Error('No access token for resource');
    }

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
    });

    if (isSuccessStatusCode(response.status)) {
        return response.blob();
    } else {
        throw Error('HTTP status ' + response.status);
    }
}
